// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { toast } from 'react-toastify';

// Internal Dependencies
import apiService from '../../services.js/apiService';
import MText from '../common/MText';
import OverLoading from '../global/OverLoading';
import { IsEmpty } from '../../common/checks';

const UnbanModal = ({ open, user, onClose, onSuccess }) => {
  const [staffPassword, setStaffPassword] = useState('');
  const [actioning, setActioning]         = useState(false);

  const handleClose = () => {
    if (!actioning) {
      setStaffPassword('');
      onClose();
    }
  };

  const executeUnban = async () => {
    if (IsEmpty(user) || IsEmpty(staffPassword)) {
      if (IsEmpty(staffPassword)) {
        toast.error('Staff password is required');
      }
      return;
    }
    setActioning(true);

    try {
      const displayName = user.username || `Shopper #${user.id}`;

      await apiService.unbanShopper(user.id, { password: staffPassword });
      toast.success(`${displayName} has been unbanned.`);

      setStaffPassword('');
      onSuccess();
    } catch (err) {
      toast.error(err.message || String(err));
    } finally {
      setActioning(false);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        PaperProps={{
          style: {
            overflowX: 'hidden',
          },
        }}
      >
        <DialogTitle>Unban this user?</DialogTitle>
        <DialogContent style={{ overflow: 'hidden' }}>
          <DialogContentText style={{ overflowWrap: 'anywhere' }}>
            This will restore full access for
            {' '}
            <strong>
              {(!IsEmpty(user) && user.username) || `shopper #${!IsEmpty(user) && user.id}`}
            </strong>
            .
            Their account will become active again immediately.
          </DialogContentText>
          <MText text="Confirm password" size={12} bold style={{ marginTop: 20 }} />
          <TextField
            fullWidth
            autoComplete="new-password"
            type="password"
            label="Enter your staff password to confirm"
            value={staffPassword}
            onChange={(e) => setStaffPassword(e.target.value)}
            variant="outlined"
            style={{ marginTop: 5, maxWidth: '100%' }}
            required
          />
        </DialogContent>
        <DialogActions style={{ padding: '12px 24px' }}>
          <Button onClick={handleClose} disabled={actioning}>
            Cancel
          </Button>
          <Button
            onClick={executeUnban}
            color="secondary"
            variant="contained"
            disabled={actioning || !staffPassword}
          >
            {actioning ? 'Unbanning...' : 'Yes, unban this user'}
          </Button>
        </DialogActions>
      </Dialog>
      {actioning && <OverLoading />}
    </>
  );
};

UnbanModal.propTypes = {
  open: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    id:       PropTypes.number,
    username: PropTypes.string,
  }),
  onClose:   PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

UnbanModal.defaultProps = {
  user: null,
};

export default UnbanModal;
